const UserSelectBar = ({ users, selectedUser, handleUserSelect }) => {
  return (
    <select
      id="typeSelect"
      value={selectedUser.id?.toString() ?? null}
      onChange={(e) => handleUserSelect(e.target.value)}
      style={{
        height: "42px",
        padding: "0 16px",
        fontSize: "0.9rem",
        fontWeight: 600,
        fontFamily: "inherit",
        color: "#3A434E",
        width: "220px",
        border: "1.5px solid #E6EDEC",
        borderRadius: "999px",
        cursor: "pointer",
        backgroundColor: "#F4F8F7",
        outline: "none",
      }}
      className="customSelect"
    >
      <option value="-1">유저를 선택하세요</option>
      {users.map((user) => (
        <option key={user.id} value={user.id}>
          {user.name || user.nickname} ({user.plan})
        </option>
      ))}
    </select>
  );
};

export default UserSelectBar;
